import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CmsConfig, I18nModule, provideConfig} from "@spartacus/core";
import {QuickOrderListModule} from "@spartacus/cart/quick-order/components";
import {
  GonvarriMyCompanyAddressesTableComponent
} from "../../components/gonvarri-my-company-addresses-table/gonvarri-my-company-addresses-table.component";

@NgModule({
  declarations: [
    GonvarriMyCompanyAddressesTableComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    QuickOrderListModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        GonvarriMyCompanyAddressesTableComponent: {
          component: GonvarriMyCompanyAddressesTableComponent
        }
      }
    })
  ]
})
export class GonvarriMyCompanyAddressesTableModule { }
